import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      role="navigation"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-lg border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-3 sm:py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
            <img
              alt="4K Dream Logo"
              className="h-8 sm:h-10 w-auto object-contain"
              src="https://static.readdy.ai/image/5c7545dbb6198b28906c423b0244c4c9/0789dc6d730dd15b6f1e8e24be7c3580.webp"
            />
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-8 text-sm font-medium text-white/80">
            <a href="#pricing" className="hover:text-white transition-colors cursor-pointer">Pricing</a>
            <a href="#avantages" className="hover:text-white transition-colors cursor-pointer">How It Works</a>
            <a href="#support" className="hover:text-white transition-colors cursor-pointer">Support</a>
            <Link to="/about" className="hover:text-white transition-colors cursor-pointer">About Us</Link>
          </div>

          {/* Right side */}
          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href="https://wa.me/12057092376"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex bg-gradient-to-r from-[#862ce0] to-[#c026d3] text-white px-4 md:px-6 py-2 rounded-lg font-semibold text-sm hover:opacity-90 transition-all whitespace-nowrap cursor-pointer"
            >
              Contact
            </a>
            <button
              className="lg:hidden text-white p-2 cursor-pointer"
              aria-label="Menu"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="lg:hidden mt-3 pb-4 border-t border-white/10 pt-4 flex flex-col gap-4">
            <a href="#pricing" className="text-white/80 hover:text-white text-sm font-medium cursor-pointer" onClick={() => setMobileOpen(false)}>Pricing</a>
            <a href="#avantages" className="text-white/80 hover:text-white text-sm font-medium cursor-pointer" onClick={() => setMobileOpen(false)}>How It Works</a>
            <a href="#support" className="text-white/80 hover:text-white text-sm font-medium cursor-pointer" onClick={() => setMobileOpen(false)}>Support</a>
            <Link to="/about" className="text-white/80 hover:text-white text-sm font-medium cursor-pointer" onClick={() => setMobileOpen(false)}>About Us</Link>
            <a
              href="https://wa.me/12057092376"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex bg-gradient-to-r from-[#862ce0] to-[#c026d3] text-white px-4 py-2 rounded-lg font-semibold text-sm hover:opacity-90 transition-all whitespace-nowrap cursor-pointer w-fit"
            >
              Contact
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
